import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { base64decodedString } from '@src/app/ecom-gift-card/ecom-giftcard.service';
import { User } from '@src/app/ecom-models/user';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { SocialsService } from '@src/app/ecom-socials/socials.service';
import { QRType } from '@src/app/enums/qr-types.enum';
import { ToastService } from '@src/app/toast/toast.service';
import detectIncognito from 'detectincognitojs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomSigninService } from './ecom-signin.service';
import { OpenExternalService } from './open-external.service';
import { SocialAuthFontEnd } from '@src/app/ecom-socials/socials.model';

@Component({
  selector: 'app-ecom-signin-new',
  templateUrl: './ecom-signin-new.component2.html',
  styleUrls: ['./ecom-signin-new.component2.scss']
})
export class EcomSigninNewComponent implements OnInit, AfterViewInit {
  // component class properties


  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];

  userServiceBase: UserServiceBase;

  male = true;

  tableCode: string = "";
  // constructor to inject the class objects  
  olarmePromoList: string[] = ['./assets/images/defaultLoyalty.png'];
  promotional: string = "";
  promotional2: string = "";
  promotional3: string = "";

  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm huhu'
  };
  showToast: boolean = false;
  toastMessage: string = "";
  drawerVisible = false
  locationCode: string = "";

  companyPkid: number = 0;
  isClosed: boolean = false;
  customerForm!: FormGroup;

  defaultLoyaltyBanner = './assets/images/defaultLoyalty.png';
  private readonly ngUnsubscribe = new Subject();
  socialProfile: SocialAuthFontEnd | null = null;
  currentUrl: string = "";


  @ViewChild('inAppModal', { static: true }) inAppModal!: ElementRef;

  inAppRef!: BsModalRef;
  showOrderTypePopup = false;

  selectedServiceType: string = 'DINE_IN';

  customerPkid = 0;

  companyLogo = "";
  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    public ecomservice: EComService,

    private webstorage: EComWebStorage,
    public activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private toastService: ToastService,
    private settingService: EcomSettingService,
    private signinService: EcomSigninService,
    public readonly _socialGlobal: SocialsService,
    private _cdr: ChangeDetectorRef,

    private ext: OpenExternalService,
    private route: ActivatedRoute) {
    this.userServiceBase = new UserServiceBase();
    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });
    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });
  }

  ngAfterViewInit() {

    this._socialGlobal
      .authObject
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async authRes => {
        //console.log(authRes);

        this.socialProfile = authRes;

        if (authRes) {
          this._cdr.detectChanges();
        }
      })


  }
  ngOnDestroy() {
    this.ngUnsubscribe.complete();
  }


  // component initialize and load the required data
  ngOnInit() {
    this.currentUrl = window.location.href;
    this.webstorage.sessionSt_serviceid = this.currentUrl;
    // Assuming 'detectIncognito' library is included
    detectIncognito().then((result) => {
      if (result.browserName === "Safari" && result.isPrivate) {
        this.inAppRef = this.modalService.show(this.inAppModal, this.configorderstatus);
      }
      this.init();
    });

  }

  async init() {


    if (this.webstorage.sessionSt_user_order_reference) {

      const localData = this.webstorage.sessionSt_user_order_reference;

      this.settingService.setCompanySetting(localData.company_setting);
      this.settingService.setUserSerivce(localData.user_service);
      this.settingService.setCompanySetting(localData.company_setting);
      this.settingService.setLocationSetting(localData.location_setting);
      this.settingService.setUserInfo(localData.user_info);
      this.router.navigate(['checkout', "reference"]);
      return;
    }

    const qp = this.route.snapshot.queryParamMap;
    const skipResume = qp.get('skipResume') === '1';
    if (!skipResume && this.webstorage.sessionSt_status_companyids) {
      const userPkid = qp.get('U');
      let query = {};
      if (userPkid) {
        query = {
          queryParams: {
            U: userPkid
          }
        }

      }

      this.router.navigate(['status-dinein'], query);
      return;
    }

    //this.webstorage.sessionSt_serviceid = this.currentUrl;

    this.webstorage.sessionSt_status_serviceid = null;
    this.settingService.setUserInfo(new User());
    this.settingService.setLocationSetting(null);
    this.customerForm = this.formBuilder.group({
      mobile: [''],
      name: [''],
      gender: ['1']
    });

    //this.toastService.show("You need to be in a specific location to access this page!", 10000);
    this.settingService.setCompanySetting(null);
    //console.log("new-signin")
    this.activatedRoute.queryParams.subscribe(async params => {
      if (params['T']) {
        this.tableCode = params['T'];
        this.settingService.setQRCodeType(QRType.Table);
      }
      if (params['L'] && params['C']) {
        this.locationCode = params['L'];
        this.companyPkid = params['C'];
        this.settingService.setQRCodeType(QRType.Store);
      }

      if (params['U']) {
        const customerPkid = base64decodedString(params['U']);

        if (customerPkid) {
          const numValue = Number(customerPkid);
          this.customerPkid = isNaN(numValue) ? 0 : numValue;
        }
      }

    });

    await this.HomeGetIP();

  }

  open(which: 'chrome' | 'edge' | 'firefox' | 'brave') {
    //this.ext.openInChrome(this.currentUrl);
    switch (which) {
      case 'chrome': this.ext.openInChrome(this.currentUrl); break;
      case 'edge': this.ext.openInEdge(this.currentUrl); break;
      case 'firefox': this.ext.openInFirefox(this.currentUrl); break;
      case 'brave': this.ext.openInBrave(this.currentUrl); break;
    }
  }

  closeAppIn() {
    this.inAppRef.hide();
  }
  async HomeGetIP() {
    if (this.webstorage.localSt_ip) {
      await this.LoadPage();
      return;
    }

    const response = await this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', false).toPromise();
    if (response.status === 200) {
      this.ecomservice.loadingPage.loading = false;
      this.webstorage.localSt_ip = response.body.ip;
      this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
      this.webstorage.localSt_countrycode = response.body.country_code2;
      await this.LoadPage();
    }


  }

  async checkPhoneNumber() {
    if (this.socialProfile) {
      this.checkSocial();
      return;
    }

    const formValue = this.customerForm.value;

    const dialCode = formValue.mobile.dialCode.replace(/\D/g, '');
    const phoneNumber = formValue.mobile.number.replace(/\D/g, '');
    const companySetting = this.settingService.getCompanySetting();

    if (!companySetting) return;

    const model = {
      KindId: 0,
      FirstName: formValue.name,
      Gender: this.male ? 'M' : 'F',
      LocationPkId: companySetting.oocls_location_pkid,
      CompanyPkid: companySetting.oocls_company_pkid,
      DialCode: dialCode,
      PhoneNumber: phoneNumber,
      CompanyId: companySetting.oocls_company_id
    }

    await this.handleVerifyUser(model);
  }

  async handleVerifyUser(model: any) {
    const res = await this.signinService.verifyUser(model).toPromise();
    if (res.isSuccess) {
      const data = res.listValue;

      this.settingService.setUserInfo(new User({
        userPkid: data.customer_pkid,
        firstName: data.customer_first_name,
        companyPkid: data.customer_company_pkid,
        locationPkid: data.customer_location_pkid,
        phoneNumber: data.customer_phone_number,
        dialCode: data.customer_country_dial_code
      }));
      this.asGuestClick();
    }
  }

  async fetchUserByPkid(model: any) {
    const res = await this.signinService.fetchUserByPkid(model).toPromise();
    if (res.isSuccess && res.listValue) {
      const data = res.listValue;

      this.settingService.setUserInfo(new User({
        userPkid: data.customer_pkid,
        firstName: data.customer_first_name,
        companyPkid: data.customer_company_pkid,
        locationPkid: data.customer_location_pkid,
        phoneNumber: data.customer_phone_number,
        dialCode: data.customer_country_dial_code
      }));

      if (!this.showOrderTypePopup) {
        this.asGuestClick();
      }
    }
  }

  async checkSocial() {

    if (!this.socialProfile) return;
    const userInfo = this.socialProfile.UserInfo;

    const companySetting = this.settingService.getCompanySetting();
    if (!companySetting) return;

    const model = {
      KindId: this.socialProfile.KindId,
      AuthId: userInfo.AuthId,
      Email: userInfo.Email,
      FirstName: userInfo.FirstName,
      LastName: userInfo.LastName,
      Gender: null,
      LocationPkId: companySetting.oocls_location_pkid,
      CompanyPkid: companySetting.oocls_company_pkid,
      CompanyId: companySetting.oocls_company_id
    }
    await this.handleVerifyUser(model);
  }

  genderClick(gender: string) {
    this.male = gender === '1' ? true : false;
  }



  async LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      await this.generateKey();
    }


    this.settingService.setDiscounts([]);
    await this.fetchBasicSettings();

  }

  async generateKey() {

    const response = await this.signinService.generateKey().toPromise();
    if (response.isSuccess) {
      this.webstorage.localSt_client_id = response.listValue.oock_client_id;
      // store public key
      this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
    }
  }

  selectServiceType(serviceType: string) {
    //
    const setting = this.settingService.getCompanySetting();
    if (setting) {
      setting.serviceType = serviceType;
      this.selectedServiceType = serviceType;

      this.settingService.setCompanySetting(setting);
    }

    this.showOrderTypePopup = false;

    if (this.customerPkid) {
      this.asGuestClick();
    }
  }

  async fetchBasicSettings() {

    const url = `${EcomNetworkUtils.GET_BASIC_SETTINGS}`;
    const param = {
      tableId: this.tableCode,
      locationId: this.locationCode,
      companyPkid: this.companyPkid
    }
    const response = await this.ecomservice.httpPost(url, param, '', true).toPromise();
    if (response.isSuccess) {
      const data = response.listValue;
      this.companyLogo = data.company_logo;

      if (!data || !data.oocls_order_open) {
        this.toastService.show("We're sorry, but our service is currently unavailable. Please try again later!", 10000);
        this.isClosed = true;
        return;
      }

      if (data.qrType === QRType.Store && !(data.store_qr && (data.store_qr_dinein || data.store_qr_takeaway))) {
        this.toastService.show("Store order is unavailable at the moment. Please try again later.", 10000);
        this.isClosed = true;
        return;
      }

      if (data.qrType === QRType.Table && !data.table_qr) {
        this.toastService.show("Table order is unavailable at the moment. Please try again later.", 10000);
        this.isClosed = true;
        return;
      }

      if (data.qrType === QRType.Store) {
        if (data.store_qr_dinein && data.store_qr_takeaway) {
          data.serviceType = "COLLECTION";
          this.showOrderTypePopup = true;
        } else {
          data.serviceType =
            data.store_qr_takeaway ? 'COLLECTION' :
              data.store_qr_dinein ? 'DINE_IN' :
                null;
        }
      }

      this.selectedServiceType = data.serviceType;
      this.settingService.setCompanySetting(data);
      if (data.banners) {
        //hard code for opah
        if (data.oocls_company_pkid === 2) {
          this.olarmePromoList = ['./assets/images/opah.png', ...data.banners];
        } else {
          this.olarmePromoList = [...this.olarmePromoList, ...data.banners];
        }
      }

      this.webstorage.sessionSt_company_clicked = data.oocls_company_name.trim().replace(/\s+/g, '-').toLowerCase();

      //this.olarmePromoList = data.banners ? data.banners : [];
      //this.promotional = data.oomls_promotional_message;
      this.promotional2 = data.oomls_slider_promotional_message;
      this.promotional3 = data.oomls_slider_promotional_message1;

      if (this.customerPkid) {
        const companySetting = this.settingService.getCompanySetting();

        if (!companySetting) return;

        const model = {
          UserPkid: this.customerPkid,
          CompanyPkid: companySetting.oocls_company_pkid,
          CompanyId: companySetting.oocls_company_id
        }
        await this.fetchUserByPkid(model);
      }

      return;

    }

    if (response.status === 401) {
      // Re-generate key
      this.webstorage.localSt_client_id = null;
      this.webstorage.localSt_olar_key = null;
      await this.LoadPage();
    }


  }

  onClickPrivacy() {
    window.open('./assets/media/Olarme_policy.pdf', '_blank');
  }


  closePopup() {
    this.closeAppIn();
    this.asGuestClick();
  }

  asGuestClick() {
    //this.webstorage.sessionSt_qrcode_type = 'QRTABLE';
    //this.orderTypeModalRef = this.modalService.show(this.orderTypeModal, this.configorderstatus);
    const setting = this.settingService.getCompanySetting();
    if (!setting) return;
    if (this.locationCode) {

      this.router.navigate(['items/m'], { queryParams: { L: this.locationCode, C: setting.oocls_company_pkid } });
      return;
    }

    if (this.tableCode) this.router.navigate(['items/m'], { queryParams: { T: this.tableCode } });

  }

  onDrawerVisibleChange() {
    this.drawerVisible = false;
  }

  serviceChange(type: string) {
    const setting = this.settingService.getCompanySetting();
    if (setting) {
      setting.serviceType = type;
      this.settingService.setCompanySetting(setting);
    }
    this.drawerVisible = false;
    this.router.navigate(['items/m'], { queryParams: { L: this.locationCode, ok: 'ok' } });
  }
}
